<template>

  <form 
    ref="form"
    class="newsletter_sign_up_form" 
    action="https://australia-southeast1-foxtware.cloudfunctions.net/shopifyNewsletterSignUp" 
    method="post"
    @submit.prevent="submit"
    @focusin="touched"
    :class="{ _thankyou: thankyou }"
  >
    <h1 v-if="!thankyou" v-html="title"></h1>
    
    <div class="newsletter_field_wrapper _full">
      <smart-field
        type="email"
        name="email"
        id="email"
        aria-label="Email"
        autocomplete="email"
        required
        :class="{ _submit_attempted: this.submitAttempted, _invalid: this.errors.email }"
        @change="cleanse"
      ></smart-field>
      <div class="newsletter_field_error" v-if="this.errors.email" v-html="this.errors.email"></div>
    </div>

    <div class="newsletter_field_wrapper _half">
      <smart-field
        type="text"
        name="firstName"
        id="firstName"
        aria-label="First Name"
        autocomplete="given-name" 
        required
        :class="{ _submit_attempted: this.submitAttempted, _invalid: this.errors.firstName }"
        @change="cleanse"
      ></smart-field>
      <div class="newsletter_field_error" v-if="this.errors.firstName" v-html="this.errors.firstName"></div>
    </div>

    <div class="newsletter_field_wrapper _half">
      <smart-field
        type="text"
        name="lastName"
        id="lastName"
        aria-label="Last Name"
        autocomplete="family-name" 
        required
        :class="{ _submit_attempted: this.submitAttempted, _invalid: this.errors.lastName }"
        @change="cleanse"
      ></smart-field>
      <div class="newsletter_field_error" v-if="this.errors.lastName" v-html="this.errors.lastName"></div>
    </div>

    <div class="newsletter_field_wrapper _half _s_full">
      <label :for="phone_input_id" class="visually-hidden">Mobile</label>
      <input 
        type="tel" 
        :id="phone_input_id" 
        name="phone" 
        autocomplete="tel" 
        required
        class="_mobile_number_input"
        :class="{ _submit_attempted: this.submitAttempted, _invalid: this.errors.phone }"
        @change="cleanse"
      >
      <div class="newsletter_field_error" v-if="this.errors.phone" v-html="this.errors.phone"></div>
    </div>

    <div class="newsletter_field_wrapper _half _s_full">
      <label for="birthday" class="visually-hidden">Birthday</label>
      <birth-date-field 
        name="dateOfBirth" 
        :max="max" 
        id="birthday"
        :data-mask="bday_format" 
        data-autofill-chars="/-"
        :class="{ _submit_attempted: this.submitAttempted, _invalid: this.errors.dateOfBirth }"
        placeholder="Bday"
        @change="cleanse"
      ></birth-date-field>
      <div class="newsletter_field_error" v-if="this.errors.dateOfBirth" v-html="this.errors.dateOfBirth"></div>
    </div>

    <div class="newsletter_field_wrapper _full" v-if="ask_location">
      <select ref="countryInput" name="countryCode" class="form-control" :data-default="default_country_code" placeholder="Country" maxlength="20" required>
        <option disabled selected>Country</option>
      </select>
    </div>

    <div class="newsletter_field_wrapper _full" v-if="ask_location">
      <select ref="provinceInput" name="provinceCode" class="form-control" placeholder="State" maxlength="40">
        <option disabled selected>State</option>
      </select>
    </div>

    <div class="newsletter_disclaimer"><div v-html="disclaimer"></div></div>

    <button type="submit" class="btn btn-primary" @click="attemptSubmit" v-html="buttonHtml" :disabled="busy">Subscribe</button>

   <div class="thankyou_display" v-if="thankyou">
      <h3 v-html="thank_you_message"></h3>
    </div>


    
  </form>
</template>

<script>
  export default {
    name: 'newsletter',
    props: ['region', 'max', 'bday_format', 'token', 'value', 'disclaimer', 'ask_location', 'default_country_code', 'phone_input_id', 'thank_you_message', 'title'],
    data() {
      return {
        submitAttempted: false,
        errors: {},
        buttonHtml: 'Sign Up Now',
        busy: false,
        thankyou: false,
      };
    },
    methods: {
      attemptSubmit: function() {
        this.submitAttempted = true;
        quietLog(this.disclaimer);
      },
      submit: async function(e) {
        if (this.busy) {
          quietLog('Cool your jets, buster');
          return;
        }

        quietLog(e);

        this.busy = true;
        this.buttonHtml = '...';

        const [
          minTime, 
          successful,
        ] = await Promise.all([
          this.wait(2000),
          this.sendRequest(),
        ]);

        if (!successful) {
          this.buttonHtml = 'Error';
          await this.wait(1000);
          this.busy = false;
          this.buttonHtml = 'Sign Up Now';

          return;
        }

        // Thank you stuff
        this.errors = {};
        this.thankyou = true;

        await this.wait(5000);
        document.dispatchEvent(new CustomEvent('newsletter:submitted', { detail: true }));
      },
      sendRequest: async function() {

        const { form } = this.$refs;
        const { method, action } = form;

        const formData = new FormData(form);
        const formDataObj = Object.fromEntries([...formData]);
        const { email, firstName, lastName, dateOfBirth, ...options } = formDataObj;
        const phone = window?.intlTelInputValidators?.[this.phone_input_id]?.getNumber() || formDataObj?.phone;

        quietLog('formData', {
          ...formDataObj,
          phone,
          options,
          config: this.region,
        });

        let response;
        try {
          response = await fetch(action, {
            method,
            headers: {
              'Content-Type': 'application/json',
              'x-wf-token': this.token,
              'x-wf-value': this.value,
            },
            body: JSON.stringify({
              ...formDataObj,
              phone,
              options,
              config: this.region,
            }),
          });

          if (!response?.ok) {
            return false;
          }

          if (response?.error) {
            return false;
          }

          let submitResult;
          try {
            submitResult = await response.json();
          } catch(err) {
            console.error(err);
            return false;
          }
          quietLog('submitResult', submitResult);

          const { success, errors, data } = submitResult;
          if (!success) {
            const dataErrors = {};
            const errorsToData = errors.map(error => {
              const { field, message } = error;
              field.forEach(f => {
                dataErrors[f] = message;
              })
            });
            this.errors = dataErrors;
            return false;
          }

          const { id } = data;
          if (!id) {
            // Something went wrong that wasn't caught, I guess?
            alert('Sorry babe, something went wrong, please try again');
            return false;
          }

          return true;
        } catch(err) {
          alert(`Soz babe, network error, please check your connection and try again.`);
          console.error('Network error', err);
          return false;
        }
      },
      cleanse: function(e) {
        e.target.classList.remove('_invalid');
      },
      wait: ms => new Promise((resolve, reject) => setTimeout(resolve, ms)),
      touched: e => {
        quietLog('touched');
        window.newsletterTouched = true;
      },
    },

    created() {
  console.log("Newsletter Component Created");
  console.log("Title from Shopify (Prop):", this.title);
  console.log("Thank You Message ", this.thank_you_message);
},

    mounted() {
      
      quietLog(this);
      const { countryInput, provinceInput } = this.$refs;

      if (!(countryInput && provinceInput)) {
        return;
      }


 console.log("Newsletter Component Mounted");
    console.log("Title from Shopify:", this.title);
    console.log("Thank You Message from Shopify:", this.thank_you_message);


      const countryProvinceSelector = new theme.CountryProvinceSelector(theme.filteredCountryTags || theme.allCountryOptionTags);

      countryProvinceSelector.build(
        countryInput, 
        provinceInput, 
        {
          onCountryChange: (provinces, countryNodeElement, provincesNodeElement) => {
            provinceInput.classList.toggle('d-none', !provinces.length);
          },
        }
      );

      const currentCountry = countryInput.value;
      if (currentCountry) {
        return;
      }
    }
  }
</script>
